var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExecutionicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2887_3592)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 0.748047,
    width: 58,
    height: 58,
    rx: 8,
    fill: "#346F98"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 0.748047,
    width: 58,
    height: 58,
    rx: 8,
    fill: "url(#paint0_linear_2887_3592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9993 35.7894C29.5292 35.7894 28.2454 35.3312 27.1478 34.4149C26.0502 33.4986 25.3605 32.3456 25.0785 30.9561H18.916V28.5394H25.0785C25.3605 27.1498 26.0502 25.9969 27.1478 25.0805C28.2454 24.1642 29.5292 23.7061 30.9993 23.7061C32.4695 23.7061 33.7533 24.1642 34.8509 25.0805C35.9485 25.9969 36.6382 27.1498 36.9202 28.5394H43.0827V30.9561H36.9202C36.6382 32.3456 35.9485 33.4986 34.8509 34.4149C33.7533 35.3312 32.4695 35.7894 30.9993 35.7894ZM30.9993 33.3727C32.0063 33.3727 32.8622 33.0203 33.5671 32.3154C34.2719 31.6106 34.6243 30.7547 34.6243 29.7477C34.6243 28.7408 34.2719 27.8849 33.5671 27.18C32.8622 26.4752 32.0063 26.1227 30.9993 26.1227C29.9924 26.1227 29.1365 26.4752 28.4316 27.18C27.7268 27.8849 27.3743 28.7408 27.3743 29.7477C27.3743 30.7547 27.7268 31.6106 28.4316 32.3154C29.1365 33.0203 29.9924 33.3727 30.9993 33.3727Z",
    fill: "#E9E9E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2887_3592",
    x: 0.791667,
    y: 0.748047,
    width: 60.4167,
    height: 60.4167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.20833
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.604167
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2887_3592"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2887_3592",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2887_3592",
    x1: 31,
    y1: 0.748047,
    x2: 31,
    y2: 58.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DD6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExecutionicon);
export default __webpack_public_path__ + "static/media/execution+icon.042f66a244aa617b8751dee8cccdd6fe.svg";
export { ForwardRef as ReactComponent };